import React from "react";
import { Chip } from "@mui/material";

const StatusChip = ({ active, activeLabel = "Active", inactiveLabel = "Inactive" }) => (
  <Chip
    label={active ? activeLabel : inactiveLabel}
    size="small"
    color={active ? "success" : "default"}
    variant={active ? "filled" : "outlined"}
  />
);

export default StatusChip;
